import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    info: {
      marginBottom: theme.spacing(2)
    },
    section: {
      margin: theme.spacing(2)
    },
    sectionContent: {
      paddingTop: 0
    },
    loading: {
      marginTop: theme.spacing(10)
    },
    storeSelect: {
      display: "flex",
      justifyContent: "center",
      margin: theme.spacing(2)
    },
    deadlinePassed: {
      color: "red"
    },
    listItemTight: {
      paddingTop: 0,
      paddingBottom: 0
    },
    buttons: {
      margin: theme.spacing(2),
      position: "fixed",
      bottom: 0,
      right: 0
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    addDialog: {
      [theme.breakpoints.up("sm")]: {
        width: "400px"
      }
    }
  })
);
